import { getJsonRequest, postJsonRequest } from '../utils/fetch';
import { TListResponse, SubscriptionItemList, SubscriptionMetadata } from './types';

type SubscriptionMetadataArgs = {
  token: string;
};
type SubscriptionProductsMetadataArgs = SubscriptionMetadataArgs & {
  productTypeId: string;
  limit?: number;
  offset?: number;
};
type SubscriptionList = TListResponse<SubscriptionItemList>;

interface SubscriptionProduct {
  id: number;
  name: string;
}

type SubscriptionProductList = TListResponse<SubscriptionProduct>;

export const getSubscriptions = (): Promise<SubscriptionList> =>
  getJsonRequest<SubscriptionList>(`subscriptions`);

export const getSubscriptionMetadata = ({
  token
}: SubscriptionMetadataArgs): Promise<SubscriptionMetadata> =>
  getJsonRequest<SubscriptionMetadata>(`subscriptions/metadata?sub_token=${token}`);

export const getSubscriptionProducts = ({
  token,
  productTypeId,
  limit = 50,
  offset
}: SubscriptionProductsMetadataArgs): Promise<SubscriptionProductList> =>
  getJsonRequest<SubscriptionProductList>(
    `subscriptions/metadata/product_types/${productTypeId}/products?sub_token=${token}&limit=${limit}&offset=${offset}`
  );

type postSubscriptionPreferenceArgs = SubscriptionMetadataArgs & {
  productTypeId: number;
  productId: number;
  notes?: string;
};

export const postSubscriptionPreference = ({
  token,
  productTypeId,
  productId,
  notes
}: postSubscriptionPreferenceArgs): Promise<unknown> =>
  postJsonRequest<unknown, unknown>(`subscriptions/metadata/preferences?sub_token=${token}`, {
    productTypeId,
    productId,
    notes
  });
